module.exports = __webpack_public_path__ + "img/行业自律.978039fb.jpg";